export const VALIDATION_REGEX = {
  /**
   * Only allows Canadian postal codes in the A1A 1A1 format (this is the
   * preferred format for DB saving).
   *
   * Note: characters D, F, I, O, Q, and U are also disallowed.
   */
  canadianPostalCode:
    /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ] \d[ABCEGHJKLMNPRSTVWXYZ]\d$/,
  email:
    /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*$/i,
  /**
   * Allows USA phone numbers in the following formats:
   * - 123 456-7890
   * - 123-456-7890
   * - 123.456.7890
   * - (123) 456-7890
   * - 1234567890 (preferred format for DB saving)
   */
  usaPhone:
    /^(?:\d{3} \d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{3}\.\d{3}\.\d{4}|\(\d{3}\) \d{3}-\d{4}|\d{10})$/,
  /**
   * Allows USA zip codes in the following formats:
   * - 12345
   * - 12345-6789
   * - 12345 6789 (preferred format for DB saving)
   */
  usaZipCode: /^\d{5}(?:[-\s]\d{4})?$/,
};
